import React, { useState } from 'react'
import {
  FaUserTie,
  FaBuilding,
  FaBullseye,
  FaGlobe,
  FaPhone,
  FaCheckCircle,
  FaTimes,
  FaBars,
  FaRegAddressCard,
} from 'react-icons/fa'
import ZynthLogoText from '../../assets/zynth-text.png'
import { Section } from '../../types/onboardingTypes'

const sections: Section[] = [
  {
    id: 1,
    title: 'User Type',
    subheading: '',
    icon: <FaUserTie />,
  },
  {
    id: 2,
    title: 'Organization Name',
    subheading: '',
    icon: <FaBuilding />,
  },
  {
    id: 3,
    title: 'Branding',
    subheading: 'Upload your logo',
    icon: <FaBullseye />,
  },
  {
    id: 4,
    title: 'Website Link',
    subheading: 'Provide your website link',
    icon: <FaGlobe />,
  },
  {
    id: 5,
    title: 'Contact Details',
    subheading: 'Provide contact details',
    icon: <FaPhone />,
  },
];

interface SidebarProps {
  lastVisitedSection: number
  visitedSections: number[]
  submittedData?: Record<number, any>
}

const Sidebar: React.FC<SidebarProps> = ({
  lastVisitedSection,
  visitedSections,
  submittedData = {},
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  return (
    <>
      <div className="lg:hidden p-4">
        <FaBars className="text-2xl cursor-pointer" onClick={toggleSidebar} />
      </div>

      <div
        className={`fixed lg:relative lg:w-64 h-screen bg-gray-100 transition-transform transform ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0`}
      >
        {isSidebarOpen && (
          <FaTimes
            className="absolute top-4 right-4 text-2xl cursor-pointer"
            onClick={toggleSidebar}
          />
        )}

        <div className="flex items-center justify-center mb-8 mt-8 mr-2 gap-1">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-all duration-300 transform "
          >
            <img
              className="h-8 hover:scale-110 active:scale-95 active:opacity-80 transition-all transform"
              src={ZynthLogoText}
              alt="Zynth"
            />
          </a>
        </div>

        <div className="relative">
          {sections.map((section, index) => {
            // Only active if currentSection matches this section's id
            let isActive = section.id === lastVisitedSection;
            // Only mark as visited if not currently active AND data was submitted
            const isVisited = !!submittedData[section.id] && !isActive;
            return (
              <div key={section.id} className={`relative w-full ${isActive ? 'bg-white' : ''}`}>
                <div
                  className={`flex items-center py-1 mb-3 lg:mb-4 xl:mb-6 space-x-4 pl-4 transition-colors duration-300 h-full ${
                    isActive ? 'border-l-4 border-[#3667B2]' : 'border-l-4 border-transparent'
                  }`}
                >
                  <div className="flex flex-col items-center">
                    <div className={`text-2xl ${isActive ? 'text-[#3667B2]' : isVisited ? 'text-[#3667B2]' : 'text-gray-400'}`}>
                      {isVisited ? <FaCheckCircle /> : section.icon}
                    </div>
                    {index < sections.length - 1 && visitedSections.includes(sections[index + 1].id) && (
                      <div className="w-1 h-2 border-l-2 border-dotted border-gray-300 mt-2"></div>
                    )}
                  </div>
                  <div>
                    <h2 className={`font-semibold text-lg ${isActive ? 'text-[#3667B2]' : isVisited ? 'text-[#3667B2]' : 'text-gray-700'}`}>{section.title}</h2>
                    <p className="text-sm text-gray-500">{section.subheading}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  )
}

export default Sidebar
